export const MAX_PASTE_IMAGE_BYTES = 10 * 1024 * 1024;

export function getClipboardImageFiles(event) {
  const files = [];
  const dt = event?.clipboardData;
  if (!dt) return files;

  const acceptFile = (file) => {
    if (!file?.type?.startsWith('image/')) return;
    if (file.size > MAX_PASTE_IMAGE_BYTES) return;
    files.push(file);
  };

  if (dt.files?.length) {
    Array.from(dt.files).forEach(acceptFile);
  }

  if (dt.items?.length) {
    Array.from(dt.items).forEach((item) => {
      if (item.kind === 'file' && item.type?.startsWith('image/')) {
        const file = item.getAsFile();
        if (file) acceptFile(file);
      }
    });
  }

  return files;
}

const IMG_STYLE = 'max-width:100%;height:auto;';

export function formatImageForWysiwygHtml(url) {
  if (!url) return '';
  return `<img src="${url}" alt="" style="${IMG_STYLE}" />`;
}
